//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import roomItem from './roomItem.vue';
export default {
  components: { roomItem },
  data() {
    return {
       isComplex:false,
       isMousedown:false,
       isMousedownList:[],    
       isMouseup:false,
       isMouseupList:[],
       buildList:[],
       saleStatusList:[],
       isTransverse:false,
       oldIndexList:[0,0,0],
       newIndexList:[0,0,0],
       mousedownIndex:0,
       mouseupIndex:0
      //  overflow: scroll;
    };
  },
  created() {
    this.handleToNextStep()
  },
 mounted(){
    console.log('model',this.model)
  },
  computed:{
      // moreChoose(){
      //    const {isMousedown,isMouseup} =this
      //    return{
      //       isMousedown,
      //       isMouseup
      //    }
      // }     
  },
  watch:{
   //   moreChoose:{
   //      handler:function(newval,oldval){
           
   //          if(newval.isMousedown&&newval.isMouseup){
   //             // this.isMousedown=false
   //             // this.isMouseup=false
   //              console.log(this.isMousedownList,this.isMouseupList)
   //              if(this.isMousedownList[0]!=this.isMouseupList[0]||this.isMousedownList[1]!=this.isMouseupList[1]||this.isMousedownList[2]!=this.isMouseupList[2]){//不是同一单元
   //                  setTimeout(()=>{
   //                      let value={
   //                        msg:'非相同单元房间不支持该操作',
   //                        type:'error'
   //                      }
   //                      let parm={content:{ type:'show_info', value:value}}
   //                      console.log('传给后台的参数',parm)
   //                      this.buildList.forEach(i=>{
   //                          i.floorBeanList.forEach(ii=>{
   //                            ii.unitBeanList.forEach(iii=>{
   //                               iii.roomBeanList.forEach(iiii=>{
   //                                    iiii.isSelect=false
   //                               })
   //                            })
   //                         })
   //                      })
   //                      this.invoke('invokeCustomEvent',parm) 
                       
   //                  }, 250)
   //              }           
   //              else{
   //                 console.log('同单元操作');
   //                 let m=this.isMouseupList[3]
   //                 let n=this.isMousedownList[3]
   //                 if(m>n){
   //                   let temp=0;
   //                   temp=m;
   //                   m=n;
   //                   n=temp;
   //                 }
   //                  for(var i=m;i<=n;i++){
   //                      //  this.isMousedownList[2]
   //                       console.log('多个个房间，房间信息：',this.buildList[this.isMousedownList[0]].floorBeanList[this.isMousedownList[1]].unitBeanList[this.isMousedownList[2]].roomBeanList[i])
   //                      //  this.dataList[this.isMousedownList[0]].unitList[this.isMousedownList[1]].houseList[i].isSelect=true

   //                  }
   //              }
   //          }
   //      },
   //      deep: true
   //   },
     buildBeanList:{
       handler:function(newval,oldval){
            this.buildList=this.cloneDeepJson(this.buildBeanList)
            this.mouseupIndex=-1//小
       },
       deep: true
     },
     saleStatusBeanList:{
       handler:function(newval,oldval){
            this.saleStatusList=this.saleStatusBeanList
       },
       deep: true
     },
     roomBean:{
       handler:function(newval,oldval){
         
            this.$set(this.roomBean,'isSelect',false)
            this.$set(this.buildList[this.indexList[0]].floorBeanList[this.indexList[1]].unitBeanList[this.indexList[2]].roomBeanList,this.indexList[3],this.roomBean) 
            //如果是新增和修改，要判断一下户名是否可编辑
            if(this.type=='new_room'||this.type=='delete_room'){
               this.$set(this.buildList[this.indexList[0]].buildHeadBean.unitBeanList[this.indexList[2]].unitHoldBeanList,this.indexList[3],this.unitHoldBean)
            }
             this.mouseupIndex=-1//小
            // this.$forceUpdate();
            // let roomBeanList=this.buildList[this.indexList[0]].floorBeanList[this.indexList[1]].unitBeanList[this.indexList[2]].roomBeanList;
            // roomBeanList[this.indexList[3]]=this.roomBean;
            // setTimeout(()=>{
            //     this.buildList[this.indexList[0]].floorBeanList[this.indexList[1]].unitBeanList[this.indexList[2]].roomBeanList=roomBeanList;//局部修改
            // },100)
            // this.$nextTick(()=>{
            //    this.buildList[this.indexList[0]].floorBeanList[this.indexList[1]].unitBeanList[this.indexList[2]].roomBeanList=roomBeanList;//局部修改
            // })
         //    this.buildList[this.newIndexList[0]].floorBeanList[this.newIndexList[1]].unitBeanList[this.newIndexList[2]].isMousedownPro=false//操作单元清空鼠标点击标识
         //  this.buildList[this.newIndexList[0]].floorBeanList[this.newIndexList[1]].unitBeanList[this.newIndexList[2]].isMouseupPro=false//操作单元清空鼠标点击标识
            console.log('this.buildList3',this.buildList)
       },
       deep: true
     },
     roomBeanList:{
       handler:function(newval,oldval){
            this.buildList[this.indexList[0]].floorBeanList[this.indexList[1]].unitBeanList[this.indexList[2]].roomBeanList=this.roomBeanList;//修改单元
            this.buildList[this.indexList[0]].floorBeanList[this.indexList[1]].unitBeanList[this.indexList[2]].roomBeanList.forEach((i)=>{
                    this.$set(i,'isSelect',false)
             })
             this.mouseupIndex=-1//小
            // this.newIndexList=[]
         //     this.buildList[this.newIndexList[0]].floorBeanList[this.newIndexList[1]].unitBeanList[this.newIndexList[2]].isMousedownPro=false//操作单元清空鼠标点击标识
         //  this.buildList[this.newIndexList[0]].floorBeanList[this.newIndexList[1]].unitBeanList[this.newIndexList[2]].isMouseupPro=false//操作单元清空鼠标点击标识
       },
       deep: true
     },
  },
  props: {
    buildBeanList: Array,
    saleStatusBeanList:Array,
    model: Object,
    getLangMsg: Function,
    invoke: Function,
    themeColor:String,
    roomBean:Object,
    indexList:Array,
    roomBeanList:Array,
    type:String,
    unitHoldBean:Object
  },
  methods: {
     mousedownFn(e){
          console.log('mousedownFn',e)
         this.oldIndexList=this.cloneDeepJson(this.newIndexList)//记录下来旧的操作单元
         this.newIndexList=e.indexList
         this.mousedownIndex=e.mousedownIndex
         // console.log('this.oldIndexList',this.oldIndexList[0],this.oldIndexList[1],this.oldIndexList[2])
         this.buildList[this.oldIndexList[0]].floorBeanList[this.oldIndexList[1]].unitBeanList[this.oldIndexList[2]].roomBeanList.forEach((i,n)=>{
            // i.isSelect=false;//旧的操作单元清空选中
            let temp=i
            temp.isSelect=false;//旧的操作单元清空选中
            this.$set(this.buildList[this.oldIndexList[0]].floorBeanList[this.oldIndexList[1]].unitBeanList[this.oldIndexList[2]].roomBeanList,n,temp) 
         })
          
          this.buildList[this.oldIndexList[0]].floorBeanList[this.oldIndexList[1]].unitBeanList[this.oldIndexList[2]].isMousedownPro=false//旧的操作单元清空鼠标点击标识
          this.buildList[this.oldIndexList[0]].floorBeanList[this.oldIndexList[1]].unitBeanList[this.oldIndexList[2]].isMouseupPro=false//旧的操作单元清空鼠标点击标识
          this.buildList[this.newIndexList[0]].floorBeanList[this.newIndexList[1]].unitBeanList[this.newIndexList[2]].isMousedownPro=true
         // let temps=this.buildList[this.newIndexList[0]].floorBeanList[this.newIndexList[1]].unitBeanList[this.newIndexList[2]].roomBeanList[this.mousedownIndex]
         // temps.isSelect=true;//按下操作单元即选中
         // this.$set(this.buildList[this.newIndexList[0]].floorBeanList[this.newIndexList[1]].unitBeanList[this.newIndexList[2]].roomBeanList,this.mousedownIndex,temps) 
         console.log('this.buildList',this.buildList)
     },
     mouseupFn(e){
        //判断是否是同一个单元，不是同一个单元
       
       if(e.indexList[0]==this.newIndexList[0]&&e.indexList[1]==this.newIndexList[1]&&e.indexList[2]==this.newIndexList[2])//是否同一单元格
       {//同一单元格
           this.buildList[this.newIndexList[0]].floorBeanList[this.newIndexList[1]].unitBeanList[this.newIndexList[2]].isMouseupPro=true
           this.mouseupIndex=e.mouseupIndex
       }else{
         //不同单元格
         this.buildList[this.newIndexList[0]].floorBeanList[this.newIndexList[1]].unitBeanList[this.newIndexList[2]].roomBeanList.forEach(i=>{
            i.isSelect=false;//旧的操作单元清空选中
         })
          this.buildList[this.newIndexList[0]].floorBeanList[this.newIndexList[1]].unitBeanList[this.newIndexList[2]].isMousedownPro=false
          this.buildList[this.newIndexList[0]].floorBeanList[this.newIndexList[1]].unitBeanList[this.newIndexList[2]].isMouseupPro=false
         console.log('不同单元格')
         
                        let value={
                          msg:'非相同单元房间不支持该操作',
                          type:'error'
                        }
                        let parm={content:{ type:'show_info', value:value}}
                        console.log('传给后台的参数',parm)
                        this.invoke('invokeCustomEvent',parm) 
                       
          
       }
        console.log('isMouseupFn',e)
     },
      cloneDeepJson(obj){
         return JSON.parse(JSON.stringify(obj))
      },
    
    handleToNextStep: function () {
      // console.log('点击1')
      this.invoke('invokeCustomEvent',{content:{ type: 'init_data', value:''}})
    },
    operation(type){
       console.log('操作',this.mouseupIndex,this.mousedownIndex)
        if(this.mouseupIndex===-1){
                let value={
                      msg:'请选择房间',
                      type:'error'
                    }
                    let parm={content:{ type:'show_info', value:value}}
                    console.log('传给后台的参数',parm)
                    this.invoke('invokeCustomEvent',parm) 
                     return
         }
       if(this.mouseupIndex==this.mousedownIndex){
           console.log('只选了一个')
           let roomId =this.buildList[this.newIndexList[0]].floorBeanList[this.newIndexList[1]].unitBeanList[this.newIndexList[2]].roomBeanList[this.mouseupIndex].id
           let indexList=this.newIndexList;
           indexList.push(this.mouseupIndex)
           let parm={content:{ type:type,value:{roomId:roomId,indexList:indexList}}}
           console.log('传给后台的参数',parm)
           this.invoke('invokeCustomEvent',parm)
       }else{
          let value={
            msg:'多个房间不支持该操作',
            type:'error'
          }
          let parm={content:{ type:'show_info', value:value}}
          console.log('传给后台的参数',parm)
          this.invoke('invokeCustomEvent',parm) 
        }    
    },
    exit(){
        let parm={content:{ type:'exit', value:''}}
           console.log('传给后台的参数',parm)
           this.invoke('invokeCustomEvent',parm)
    },
    changeHoldname(e,num,n,nn){
      console.log(e.target.value,num,n,nn,'e')
      //  if(e.target.value){
         // let indexList=
           let value={
            unitHoldId:this.buildList[num].buildHeadBean.unitBeanList[n].unitHoldBeanList[nn].id,
            unitHoldName:this.buildList[num].buildHeadBean.unitBeanList[n].unitHoldBeanList[nn].name,

         }
         let parm={content:{ type:'edit_unitholdname', value:value}}
         console.log('传给后台的参数',parm)
         this.invoke('invokeCustomEvent',parm) 
      //  }
    },
    merge(flag){//0：向右合并，1：向左合并
         console.log(flag)

         let m=this.mouseupIndex//小
         let n=this.mousedownIndex//大
         
         let targetRoomId='';
         let sourceRoomIds=[];
         let roomBeanList=[]//单元格数组
         if(m>n){
            let temp=0;
            temp=m;
            m=n;
            n=temp; 
         }
         if(m===-1){
                let value={
                      msg:'请选择房间',
                      type:'error'
                    }
                    let parm={content:{ type:'show_info', value:value}}
                    console.log('传给后台的参数',parm)
                    this.invoke('invokeCustomEvent',parm) 
                     return
         }
         roomBeanList=this.buildList[this.newIndexList[0]].floorBeanList[this.newIndexList[1]].unitBeanList[this.newIndexList[2]].roomBeanList
         if(m!=n){//选了不止一个房间
            for(var i=m;i<=n;i++){
                 sourceRoomIds.push(roomBeanList[i].id)    
             }
             if(flag==0){
                  targetRoomId=roomBeanList[m].id
              }else{
                  targetRoomId=roomBeanList[n].id
              }
         }else{//只选了一个房间
              console.log('只选了一个房间')
              if(flag==0){//向右合并
                let length=roomBeanList.length//单元格的长度
                 if(m+2>length){
                  let value={
                      msg:'该房间不支持向右合并',
                      type:'error'
                    }
                    let parm={content:{ type:'show_info', value:value}}
                    console.log('传给后台的参数',parm)
                    this.invoke('invokeCustomEvent',parm) 
                     return
                 }else{
                    sourceRoomIds.push(roomBeanList[m].id)
                    sourceRoomIds.push(roomBeanList[m+1].id)
                    targetRoomId=roomBeanList[m].id
                 }
                
              }else{//向左合并
                  if(m==0){
                     let value={
                      msg:'该房间不支持向左合并',
                      type:'error'
                    }
                    let parm={content:{ type:'show_info', value:value}}
                    console.log('传给后台的参数',parm)
                    this.invoke('invokeCustomEvent',parm) 
                     return
                  }else{
                      sourceRoomIds.push(roomBeanList[m-1].id)
                      sourceRoomIds.push(roomBeanList[m].id)
                      targetRoomId=roomBeanList[m].id
                  }
                  
              }
          }
          console.log('合并targetRoomId',targetRoomId)
          console.log('多个个房间id：',sourceRoomIds)
          let indexList=this.newIndexList
          let parm={content:{ type:'merge_rooms', value:{targetRoomId:targetRoomId,sourceRoomIds:sourceRoomIds,indexList:indexList}}}
          console.log('传给后台的参数',parm)
          this.invoke('invokeCustomEvent',parm)
     },
    getBg(color){
       let style=''
       let bg='background-color:'+color+';';
       style=bg;
        if(color=='#fff'||color=='#FFF'||color=='#FFFFFF'||color=='#ffffff'){
            let border='border:1px solid #CECECE;width:8px;height:8px;';
            style=style+border
        }
      // console.log('color',color,'style',style)
      return style
    },
    getItemBg(salesStatus,init){
       let color='#fff';
        this.saleStatusBeanList.forEach(i=>{
           if(i.number==salesStatus){
              color=i.color
           }
       })
       if(!init){
          color='#fff';
       }
       let style=''
       let bg='background-color:'+color+';';
       style=bg
        if(color=='#fff'||color=='#FFF'||color=='#FFFFFF'||color=='#ffffff'){
            let border='color:#212121;';
            if(init){
               border+='border:1px solid #ccc;box-sizing: border-box;line-height:20px;'
            }
            style=style+border
        }
       return style
    },
     getWidth(n,salesStatus,init,isMore){
        
        if(!n){
           n=1
        }
        let w=60*n+4*(n-1);
      //   let m=2*n;
        let wStyle='width:'+w+'px;';
        if(isMore==1){
           wStyle='width:102px;';
        }
        if(isMore==2){
           wStyle='width:138px;';
        }
        let mStyle='margin:2px 2px;';
        let style=this.getItemBg(salesStatus,init)
      //   console.log('wStyle+mStyle+style',wStyle+mStyle)
        return wStyle+mStyle+style
     },
     mousedown(e,num,n,nn,nnn){
      //   console.log('this.dataList',this.dataList)
        console.log('e1',e,n,nn,nnn)
        //按下按钮，所有的都清空
         this.buildList.forEach(i=>{
                  i.floorBeanList.forEach(ii=>{
                     ii.unitBeanList.forEach(iii=>{
                          iii.roomBeanList.forEach(iiii=>{
                              iiii.isSelect=false
                             })
                      })
                  })
         })  
        if(this.isMousedown){
           console.log('e12',e,n,nn,nnn)           
            this.isMouseup=false
        }
        this.isMousedown=true
        this.isMousedownList=[num,n,nn,nnn]
        this.buildList[num].floorBeanList[n].unitBeanList[nn].roomBeanList[nnn].isSelect=true
     },
     mousemove(e,num,n,nn,nnn){
        if(this.isMousedown&&!this.isMouseup){
           
            if(this.isMousedownList[0]==num&&this.isMousedownList[1]==n&&this.isMousedownList[2]==nn){
              
               this.buildList[num].floorBeanList[n].unitBeanList[nn].roomBeanList[nnn].isSelect=true
              
            } 
        }
      // this.dataList[n].unitList[nn].houseList[nnn].isSelect=true
     },
     mouseup(e,num,n,nn,nnn){
        console.log('e3',e,n,nn,nnn)
         this.isMouseupList=[num,n,nn,nnn]
         this.isMouseup=true
          if(this.isMousedownList[0]==this.isMouseupList[0]&&this.isMousedownList[1]==this.isMouseupList[1]&&this.isMousedownList[2]==this.isMouseupList[2]&&this.isMousedownList[3]==this.isMouseupList[3]){
            console.log('只选了一个房间，房间信息：',this.buildList[num].floorBeanList[n].unitBeanList[nn].roomBeanList[nnn]) 
            return
          }
        
        this.buildList[num].floorBeanList[n].unitBeanList[nn].roomBeanList[nnn].isSelect=true
     }
  }
};
